/** @jsxImportSource @emotion/react */
import { Typography, useTheme } from '@quickbit/qb-design-system';
import { EnableMfaAuth } from './EnableMfaAuth';
export const SecuritySettings = () => {
  const { spacing } = useTheme();
  return (
    <div css={{ width: '100%' }}>
      <Typography variant="heading2">Security</Typography>
      <div css={{ marginTop: spacing.xxxs }}>
        <EnableMfaAuth />
      </div>
    </div>
  );
};
